import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AnimateModule, HeaderComponent, WwwAppState } from '@pro-connect/shared';
import { select } from '@ngxs/store';
import { CityTopComponent } from './components/city-top/city-top.component';
import { CityIntroComponent } from './components/city-intro/city-intro.component';
import { CityPlanComponent } from './components/city-plan/city-plan.component';
import { CityRulesComponent } from './components/city-rules/city-rules.component';
import { CityCheckRestComponent } from './components/city-check-rest/city-check-rest.component';

@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AnimateModule,
    CityTopComponent,
    HeaderComponent,
    CityIntroComponent,
    CityPlanComponent,
    CityRulesComponent,
    CityCheckRestComponent,
  ],
})
export class CityComponent {
  public user = select(WwwAppState.user);
  public bannerUrl = input.required<string>();
  public cityName = input.required<string>();
  public dates = input.required<string>();
  public intro = input.required<{ img: string; title: string; desc: string }>();
  public plan = input.required<{ title: string; list: string[] }[]>();
  public photos = input.required<string[]>();
  public planImg = input.required<string>();
  public showCity = input.required<string>();

  constructor() {}
}
